import React from 'react';
import classnames from 'classnames';
import ChevronRight from 'components/assets/chevron-right.svg';
import { Link } from 'components/link/Link';

import s from './Pagination.module.scss';

type Props = {
  href: string | { pathname: string; query: { page?: string | number } };
  index?: number | string;
  current?: number;
  direction?: 'left' | 'right';
  color?: 'brand' | 'white' | 'dark';
  disabled?: boolean;
  tabIndex?: number;
};

export const PaginationButton = ({
  href,
  index,
  current,
  direction,
  color = 'white',
  disabled,
  tabIndex = 0,
  ...rest
}: Props) => {
  const Tag = !href ? 'button' : Link;

  return (
    <Tag
      href={href}
      disabled={disabled || typeof index === 'string'}
      className={classnames(s.button, {
        [s.left]: direction === 'left',
        [s.brand]: color === 'brand',
        [s.white]: color === 'white',
        [s.dark]: color === 'dark',
        [s.active]: current && current === index,
        [s.disabled]: disabled || typeof index === 'string',
      })}
      tabIndex={tabIndex}
      {...rest}
    >
      {index || (
        <span className={s.button__icon}>
          <ChevronRight />
        </span>
      )}
    </Tag>
  );
};
